import {
  Autocomplete,
  Box,
  FormHelperText,
  TextField,
  AutocompleteProps,
  Chip,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { HookFormComponentProps } from 'ui-component/HookFormComponents/types';

type HookFormAutocompleteFreeSoloStringProps = {
  label: string;
  helperText?: string;
} & HookFormComponentProps &
  Omit<AutocompleteProps<string, true, false, false>, 'renderInput'>;

export const HookFormAutocompleteFreeSoloString = ({
  name = '',
  control,
  options,
  label,
  errors,
  disabled,
  helperText,
}: HookFormAutocompleteFreeSoloStringProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value, onBlur, ref } }) => (
      <Autocomplete
        multiple
        blurOnSelect={false}
        options={options}
        value={value}
        onChange={(__, data) => onChange(data)}
        onBlur={onBlur}
        renderInput={(params) => (
          <Box sx={{ mb: 2 }}>
            <TextField {...params} label={label} fullWidth inputRef={ref} />
            {helperText && (
              <FormHelperText id={`${name}HelperText`}>
                {helperText}
              </FormHelperText>
            )}
            {errors?.[name]?.message && (
              <FormHelperText error id={`${name}Error`}>
                {errors?.[name]?.message}
              </FormHelperText>
            )}
          </Box>
        )}
        renderTags={(v: readonly string[], getTagProps) =>
          value.map((option: string, index: number) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip variant="outlined" label={option} key={key} {...tagProps} />
            );
          })
        }
        disabled={disabled}
        freeSolo
      />
    )}
  />
);
